import { LocalDate, LocalTime } from '@js-joda/core';

import { useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { useCurrentPractitionerConfidentialityMode } from '~libs.shared.account';

import { MedicalInformationAttachments } from '../shared/fields/MedicalInformationAttachments';
import { MedicalInformationConfidentialityLevelField } from '../shared/fields/MedicalInformationConfidentialityLevelField/MedicalInformationConfidentialityLevelField';
import { MedicalInformationDescriptionTextarea } from '../shared/fields/MedicalInformationDescriptionTextarea';

import { ExaminationDatePicker } from './fields/ExaminationDatePicker';
import { ExaminationTimePicker } from './fields/ExaminationTimePicker';
import { ProcedureSelector } from './fields/ProcedureSelector';
import { MedicalImagingEntryFormBean, MedicalImagingEntryFormController } from './MedicalImagingEntryForm.types';

type MedicalImagingEntryFormRenderProps = Pick<MedicalImagingEntryFormController, 'handleSubmit' | 'formState'>;

type MedicalImagingEntryFormProps = {
   readonly medicalInformationId: number;
   readonly children: (renderProps: MedicalImagingEntryFormRenderProps) => JSX.Element;
};

export const MedicalImagingEntryForm = (props: MedicalImagingEntryFormProps): JSX.Element => {
   const defaultConfidentialityLevel = useCurrentPractitionerConfidentialityMode();
   const { register, control, handleSubmit, formState, sync } = useFormController<MedicalImagingEntryFormBean>({
      description: undefined,
      examinationDate: LocalDate.now(),
      examinationTime: LocalTime.now(),
      icd9Procedure: undefined,
      confidentialityLevel: defaultConfidentialityLevel,
   });

   return (
      <StyledFlex direction={'column'} gap={'24px'}>
         <ProcedureSelector register={register} />
         <StyledFlex gap={'24px'}>
            {/* TODO: DREGAB-18385 */}
            <ExaminationDatePicker register={register} />
            <ExaminationTimePicker register={register} />
         </StyledFlex>
         <MedicalInformationDescriptionTextarea register={register} control={control} required maxLength={10000} />
         <MedicalInformationConfidentialityLevelField register={register} />
         <MedicalInformationAttachments
            controller={register('attachments')}
            medicalInformationId={props.medicalInformationId}
            sync={sync}
         />

         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </StyledFlex>
   );
};
